<template>
<div id="impressum" class="overlay" @click="closeOverlay()">
  <div class="bg-white wrapper">
    <a class="close" href="#">&times;</a>
    <div>
      <h4>Herausgeber</h4>
      <p>Stiftung Familienunternehmen</p>
      <p>Prinzregentenstraße 50</p>
      <p>D-80538 München</p>
      <p>Telefon: +49 (0) 89 / 12 76 400 - 02</p>
      <p>Telefax: +49 (0) 89 / 12 76 400 - 09</p>
      <p>E-Mail: <a href="mailto:info@familienunternehmen.de">info@familienunternehmen.de</a></p>
      <p><a href="http://www.familienunternehmen.de" target="blank">www.familienunternehmen.de</a></p>
    </div>
    <div>
      <h4>Bearbeitet von:</h4>
      <p>Hannah Gundert, ZEW</p>
      <p>Prof. Dr. Friedrich Heinemann, ZEW</p>
      <p>Dr. Margit Kraus, Calculus Consult</p>
      <p>Dr. Stefan Weck, ZEW</p>
    </div>
    <div>
      <p>ZEW – Leibniz-Zentrum für Europäische Wirtschaftsforschung GmbH</p>
    </div>
    <div>
      <p>Calculus Consult</p>
    </div>
    <div>
      <p>© Stiftung Familienunternehmen,<br>München 2025</p>
    </div>
  </div>
</div>
</template>


<script>
export default {
  name: 'overlays',
  methods: {
    closeOverlay() {
      window.history.back();
    },
  },
  mounted() {
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

// overlays

.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  transition: opacity 0.5s;
  visibility: hidden;
  opacity: 0;
  font-size: 12px;
  overflow-y: scroll;
  display: grid;

  &:target {
    visibility: visible;
    transition: opacity 0.5s;
    opacity: 1;
    z-index: 1000;
  }

  .wrapper {
    > div {
      margin-bottom: $padding-default;
    }
  }

  .close {
    position: absolute;
    top: -40px;
    top : 0;
    right: 0;
    font-size: 28px;
    font-weight: bold;
    text-decoration: none;
    color: $color-white;
    @extend .animateAll;

    &:hover {
      color: $color-brand;
    }

  }

  > * {
    position: relative;
    margin: auto;
    padding: 20px 15px 5px 15px;
    background: $color-white;
    width: 70%;
    border: 1px solid $color-brand;
    text-align: left;
    max-width: 240px;
  }


  h3 {
    margin-top: 0;
    margin-bottom: 5px;
  }

  span {
    display: block;
  }

  p {
    padding: 1px 0;
  }

  a {
    color: $color-link;
    text-decoration: underline;
  }
}


</style>
